//following keys are expected to be the table of users collection.
import me from './avatars/me.jpeg';
import kaiming from './avatars/kaiminghe.jpg';
import rohit from './avatars/rohit.png';
import thomas from './avatars/thomas.jpg';

export default [
    {
        id: "00001",
        userId: "jonychoi",
        name: "Su Hyung Choi",
        avatar: me,
        briefIntroduction: "Undergraduate student researching in Artificial Intelligence, Computer Vision",
        fullIntroduction: "",
        workingPlace: "CVLAB @ Korea University",
        location: "Seoul, South Korea",
        position: "Research Intern",
        contact: {
            email: "thesky7@korea.ac.kr",
            phone: "",
            homepage: "jonychoi.github.io",
            github: "jonychoi",
            twitter: "",
        },
        activities: [],
        googleScholar: "",
        awards: "",
        researchInterests: ["Computer Vision", "Deep Learning"],
    },
    {
        id: "00004",
        userId: "rohit",
        name: "Rohit Girdhar",
        avatar: rohit,
        briefIntroduction: "Research Scientist at Facebook AI",
        fullIntroduction: "I am a research scientist at Facebook AI Research (FAIR) working on computer vision and machine learning. My current research focuses on modeling people and scenes over (3D) space and time, with applications including 3D recognition, video understanding and physical reasoning. I obtained a PhD from Carnegie Mellon University (CMU) where I worked with Deva Ramanan (here's a link to my dissertation). Earlier I graduated with a masters from CMU as well, working with Martial Hebert, Abhinav Gupta, Kris Kitani and David Fouhey as a Siebel Scholar. Even before I was a CS undergrad at IIIT, Hyderabad, working with C. V. Jawahar. I have also been fortunate to work with some amazing people through internships, at DeepMind (with Andrew Zisserman, João Carreira and Carl Doersch), Adobe Research (with Josef Sivic and Bryan Russell) and Facebook AI (with Lorenzo Torresani, Georgia Gkioxari and Du Tran).",
        workingPlace: "Facebook AI Research (FAIR)",
        location: "Newyork",
        position: "Research Scientist",
        contact: {
            email: "rgirdhar@alumni.cmu.edu",
            phone: "",
            homepage: "https://rohitgirdhar.github.io/",
            github: "rohitgirdhar",
            twitter: "_rohitgirdhar_",
        },
        activities: [],
        googleScholar: "https://scholar.google.co.in/citations?user=7cuwdr8AAAAJ&hl=en",
        awards: [],
        researchInterests: ["3D recognition", "Video Understanding", "Physical Reasoning"]
    },
    {
        id: "00002",
        userId: "kaiminghe",
        name: "Kaming He",
        avatar: kaiming,
        briefIntroduction: "Research Scientist at Facebook AI",
        fullIntroduction: "I am a Research Scientist at Facebook AI Research (FAIR) as of 2016. Before that I was with Microsoft Research Asia (MSRA), which I joined in 2011 after receiving my PhD. My research interests are in computer vision and deep learning. I am a recipient of the PAMI Young Researcher Award in 2018, the Best Paper Award in CVPR 2009, CVPR 2016, ICCV 2017, the Best Student Paper Award in ICCV 2017, the Best Paper Honorable Mention in ECCV 2018, CVPR 2021, and the Everingham Prize in ICCV 2021. My paper on Deep Residual Networks (ResNets) is the most cited paper in all areas in Google Scholar Metrics 2020. Applications of ResNets also include language, speech, and AlphaGo.",
        workingPlace: "Facebook AI Research (FAIR)",
        location: "Menlo Park, CA",
        position: "Research Scientist",
        contact: {
            email: "kaiminghe@fb.com",
            phone: "",
            homepage: "http://kaiminghe.com",
            github: "",
            twitter: "",
        },
        activities: [
            "Program Chair: ICCV 2023",
            "Area Chair: CVPR 2016, ICCV 2017, CVPR 2018, ECCV 2018, CVPR 2020, CVPR 2021",
            "Associate Editor: IJCV 2016 - 2019",
            "Co-organize a tutorial on Visual Recognition at ECCV 2018.",
            "Co-organize a tutorial on Visual Recognition at CVPR 2018.",
            "Co-organize a tutorial on Instance-level Recognition at ICCV 2017.",
            "Co-organize a tutorial on Deep Learning for Objects and Scenes at CVPR 2017.",
            "Invited to give a tutorial on Deep Residual Networks at ICML 2016.",
            "Co-organize a tutorial on Object Detection at ICCV 2015.",
        ],
        googleScholar: "https://scholar.google.com/citations?user=DhtAFkwAAAAJ&hl=en",
        awards: ["PAMI Everingham Prize, 2021", "CVPR Best Paper Honorable Mention, 2021", "ECCV Best Paper Honorable Mention, 2018", "PAMI Young Researcher Award, 2018", "ICCV Best Paper Award (Marr Prize), 2017", "ICCV Best Student Paper Award, 2017", "CVPR Best Paper Award, 2016", "CVPR Best Paper Award, 2009", "Outstanding Reviewer: CVPR 2015, ICCV 2015, CVPR 2017", "Microsoft Research Asia Fellowship, 2009", "Microsoft Research Asia Young Fellowship, 2006"],
        researchInterests: ["Computer Vision", "Deep Learning"],
    },
    {
        id: "00005",
        userId: "mannat",
        name: "Mannat Singh",
        avatar: "https://scholar.googleusercontent.com/citations?view_op=medium_photo&user=QOO8OCcAAAAJ&citpid=4",
        briefIntroduction: "Research Engineer at Facebook AI",
        fullIntroduction: "",
        workingPlace: "Facebook AI Research (FAIR)",
        location: "Greater Newyork City Area",
        position: "Research Engineer",
        contact: {
            email: "",
            phone: "",
            homepage: "https://github.com/mannatsingh",
            github: "mannatsingh",
            twitter: "",
        },
        activities: [],
        googleScholar: "https://scholar.google.com/citations?user=QOO8OCcAAAAJ&hl=en",
        awards: [],
        researchInterests: ["Computer Vision", "Machine Learning"]
    },
    {
        id: "00006",
        userId: "thomas",
        name: "Thomas Müller",
        avatar: thomas,
        briefIntroduction: "Senior Research Scientist at NVIDIA",
        fullIntroduction: "Hi there, I'm Thomas! I'm passionate about all kinds of nerdy things like AI, physics, space travel, computers, music, etc. I am also a senior research scientist at NVIDIA where I work on machine learning and computer graphics. Before that, I received a PhD from ETH and Disney Research, where I had the pleasure to integrate some of my work into Disney's Hyperion Renderer. In my free time, I am most notably involved in developing the online rhythm game osu!. I also enjoy working on all kinds of pet projects. Drop me an email if you would like to chat!",
        workingPlace: "NVIDIA",
        location: "",
        position: "Senior Research Scientist",
        contact: {
            email: "thomas94@gmx.net",
            phone: "",
            homepage: "https://tom94.net/",
            github: "",
            twitter: "",
        },
        activities: [],
        googleScholar: "https://scholar.google.ch/citations?user=csrnbFYAAAAJ&hl=en",
        awards: [],
        researchInterests: ["Artificial Intelligence", "Machine Learning", "Real-Time Rendering"]
    },
]